<template>
  <DialogBase
    :visible="dialogVisible"
    title="Cập nhật số điện thoại nhận tin nhắn SMS"
    size="sm"
    width="550px"
    top="15vh"
    :close-on-click-modal="false"
    :confirm-loading="loadingButton"
    :cancel-text="$t('button.close')"
    :confirm-text="$t('button.save')"
    @update:visible="handleVisibleUpdate"
    @cancel="closeDialogByButton"
    @confirm="submitForm"
  >
    <el-form
      :model="userData"
      label-width="140px"
      label-position="left"
      :rules="rules"
      ref="userData"
    >
      <el-form-item label="Số điện thoại cũ">
        <span>{{ userData.oldPhone }}</span>
      </el-form-item>
      <el-form-item label="Số điện thoại mới" prop="newPhone">
        <el-input
          type="number"
          min="0"
          max="0"
          v-model.trim="userData.newPhone"
          placeholder="Nhập Số điện thoại nhận SMS"
        ></el-input>
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import CommonOnekidsService from "@/services/CommonService/CommonOnekidsService";
export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      userData: {
        id: "",
        appType: "",
        oldPhone: "",
        newPhone: "",
      },
      loadingButton: false,
      rules: {
        newPhone: [
          {
            min: 10,
            max: 10,
            message: "Số điện thoại bao gồm 10 số",
            trigger: "change",
          },
          {
            required: true,
            message: "Số điện thoại không được để trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    handleVisibleUpdate(value) {
      if (!value) {
        this.closeDialog();
      }
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      this.resetFormData();
    },
    //click when click button
    closeDialogByButton() {
      this.$emit("dialog-close");
      this.resetFormData();
    },
    resetFormData() {
      setTimeout(() => {
        this.$refs["userData"].resetFields();
      }, 200);
    },
    submitForm() {
      this.$refs["userData"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          CommonOnekidsService.updatePhoneSMS(this.userData)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });

              setTimeout(() => {
                this.closeDialogByButton();
              }, 500);
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },
    getChangePhoneSMSInitial(objectData) {
      this.userData = objectData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
